import { Outlet } from "react-router-dom";
import BottomNav from "./BottomNav";

export default function MobileShell({ variant = "consumer", children }) {
    return (
        <div className="min-h-[100dvh] w-full bg-slate-100 flex justify-center">
            <div
                data-testid="mobile-shell"
                className="relative w-full max-w-[440px] min-h-[100dvh] bg-white sm:my-4 sm:rounded-[2.5rem] sm:shadow-2xl sm:overflow-hidden sm:max-h-[920px] sm:min-h-[820px] flex flex-col"
            >
                <div className="flex-1 overflow-y-auto pb-24 scrollbar-hide">{children || <Outlet />}</div>
                <BottomNav variant={variant} />
            </div>
        </div>
    );
}
